import React from "react";
import "./Property_consultation.css";

const PropertyConsultationForm = () => {
  return (
    <div className="consultation-wrapper">
      <h2>🏡 Property Consultation</h2>
      <p>Get expert guidance for your dream property</p>

      <form className="consultation-form">
        <div className="input-group">
          <input type="text" required />
          <label>Full Name</label>
        </div>

        <div className="input-group">
          <input type="email" required />
          <label>Email Address</label>
        </div>

        <div className="input-group">
          <input type="tel" required />
          <label>Phone Number</label>
        </div>

        <div className="input-group">
          <select required>
            <option value=""></option>
            <option>House Construction</option>
            <option>Apartment Purchase</option>
            <option>Villa Construction</option>
            <option>Renovation</option>
            <option>Other</option>
          </select>
          <label>Consultation Type</label>
        </div>

        <div className="input-group">
          <textarea rows="3" required></textarea>
          <label>Your Requirement</label>
        </div>

        <button type="submit">Request Consultation</button>
      </form>
    </div>
  );
};

export default PropertyConsultationForm;
